module.exports = __webpack_public_path__ + "img/0A.07212ecb.png";